module.exports = __webpack_public_path__ + "static/media/question1.ab04345f.svg";